import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=a2acc4dc&"
import script from "./MultiSelect.vue?vue&type=script&lang=ts&"
export * from "./MultiSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports